import Joi from 'joi';

export const CabinetSchema = Joi.object({
  name: Joi.string().required(),
  startDate: Joi.date().required(),
});
